import { render, staticRenderFns } from "./groupPurchaseDetail.vue?vue&type=template&id=b0e05fe0&scoped=true"
import script from "./groupPurchaseDetail.vue?vue&type=script&lang=js"
export * from "./groupPurchaseDetail.vue?vue&type=script&lang=js"
import style0 from "./groupPurchaseDetail.vue?vue&type=style&index=0&id=b0e05fe0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e05fe0",
  null
  
)

export default component.exports